document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.getElementById('toggleButton');
  const table = document.getElementById('ordersTable');
  const tbody = table.querySelector('tbody');
  const allRows = tbody.querySelectorAll('tr');

  if (!toggleButton || !table || !tbody) return;
  
  let showingAll = false;
  
  function getVisibleRowCount() {
    return window.innerWidth >= 990 ? 5 : 1;
  }
  
  function updateRowVisibility() {
    const maxVisibleRows = showingAll ? allRows.length : getVisibleRowCount();
    const isWideScreen = window.innerWidth >= 990;
    
    allRows.forEach((row, index) => {
      row.style.display = index < maxVisibleRows ? (isWideScreen ? 'table-row' : 'flex') : 'none';
    });
    
    const textNode = toggleButton.childNodes[0];
    textNode.nodeValue = showingAll ? 'Se færre ordre' : 'Se alle ordre';
  }
  
  updateRowVisibility();
  
  toggleButton.addEventListener('click', function() {
    showingAll = !showingAll;
    updateRowVisibility();
  });
  
  window.addEventListener('resize', function() {
    if (!showingAll) {
      updateRowVisibility();
    }
  });
});
